import { UI, GlobalState } from '@leverege/ui-redux';
import { getCompanyAndLocationIdsFromUrl } from '../util/Url';
import { ACTIONS_TYPE, COMPANY_VAS } from '../constants';
export default {
  id: 'recovr.blockerHook.navLogo',
  matches: {
    objectType: '*'
  },
  execute: async ({
    actions
  }) => {
    const {
      locationId,
      companyId
    } = getCompanyAndLocationIdsFromUrl(GlobalState.get().router?.location.pathname);
    const currentState = GlobalState.get();
    const currentLogo = currentState?.ui?.['molten.navTitleVariantOverride'];

    // change mobile and website logo based on company vas, but only if it differs from current
    const setNavLogo = (logo, mobileLogo) => {
      if (currentLogo !== logo) {
        GlobalState.dispatch(UI.set('molten.navTitleVariantOverride', logo));
        GlobalState.dispatch(UI.set('molten.mobileNavTitleVariantOverride', mobileLogo));
      }
    };

    // check if location or company is present in url, then check if theres an associated action item to determine vas
    if (companyId || locationId) {
      const objectType = actions.relationship.options.objectType;
      const locationOrCompanyObjectType = objectType === 'location' || objectType === 'company';
      if (actions?.type === ACTIONS_TYPE.ITEM && locationOrCompanyObjectType) {
        const device = await GlobalState.dispatch(actions.get());
        if (device?.data?.vas === COMPANY_VAS.CADA) {
          setNavLogo('navLogoCada', 'mobileNavLogoCada');
        } else {
          setNavLogo('navLogo', 'mobileNavLogo');
        }
      }
    } else {
      // default to recovr logo
      setNavLogo('navLogo', 'mobileNavLogo');
    }
  }
};